import React, { useState ,useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { IoCloseSharp, BsImages } from "../../components/utils/icons";
import { useStateContext } from '../../context/ContextProvider';
import { EditTextQill } from './utils';
import { DLabel, DSpinButton, TextArea } from '../utils/Form';

import { toast } from 'react-toastify';
import { Loader } from '../utils';

import {useParams} from "react-router-dom"
import { BaseUrl, media } from '../../server';
import { getReview } from '../../redux/actions/reviews';
function EditReview() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();

  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
 
  const {id}=useParams()

  useEffect(() => {
   dispatch(getReview(id))

  }, [ dispatch ,id]);
  const {reviewData ,isLoading}=useSelector((state)=>state.Reviews)
  const [titleAr, setTitleAr] = useState( reviewData?.titleAr);
  const [titleEn, setTitleEn] = useState(reviewData?.titleEn );
  const [textEn, setTextEn] = useState(reviewData?.textEn );

  const [textAr, setTextAr] = useState(reviewData?.textAr);
  const [date ,setDate]=useState(reviewData?.date)
  const [image, setImage] = useState(reviewData?.Image);
  const [imageShow, setImageShow] = useState({url:`${media}${reviewData?.Image}`});

  useEffect(() => {
    if (reviewData) {
      setTitleAr(reviewData.titleAr );
      setTitleEn(reviewData.titleEn );
      setTextEn(reviewData.textEn );
      setTextAr(reviewData.textAr);
      setDate(reviewData.date);
      setImage(reviewData.Image );
      setImageShow({ url: `${media}${reviewData.Image}`});
    }
  }, [reviewData]);

  const inmageHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setImageShow(imageUrl);
    }
  };

  const changeImage = (img) => {
    if (img) {
      const tempUrl = { url: URL.createObjectURL(img) }; // كائن مباشر
      setImageShow(tempUrl);
      setImage(img);
    }
  };

  const removeImage = () => {
    setImage();
    setImageShow();
  };

  const Updatereview = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
        const { data } = await axios.put(`${BaseUrl}/reviews/${id}`, newForm, config , );

        // عرض رسالة نجاح
        if(data.success){
          toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t( "Review updated successfully!")}</span>);

          // إعادة تعيين الحالات
          setIsSpinner(false);
        }
      

    } catch (error) {
        // عرض رسالة خطأ
        toast.error(error.response?.data?.message);
        setIsSpinner(false);
    }
};
const handleSubmit = (e) => {
  e.preventDefault();
  setIsSpinner(true);
  const newForm = new FormData();

  // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها
  if (image instanceof File) {
    newForm.append("file", image);
  }

  newForm.append("date", date);
  newForm.append("titleAr", titleAr);
  newForm.append("titleEn", titleEn);
  newForm.append("textAr", textAr);
  newForm.append("textEn", textEn);

  Updatereview(newForm);
};

  return (<>{
    isLoading   ? (<Loader />) :(
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
        <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
          {t("Edit Review")}
        </h3>
        <form onSubmit={handleSubmit}>
          <br />
          <div>
      
          <DLabel
              labelText="Title (Ar)"
              value={titleAr}
              onChange={(e)=> {setTitleAr(e.target.value)}}

              type="text"
              name="titleAr"
            />
             <DLabel
              labelText="Title (En)"
              value={titleEn}
              onChange={(e)=> {setTitleEn(e.target.value)}}

              type="text"
              name="titleAr"
            />
            <DLabel
              labelText="Date"
              value={date}
              onChange={(e)=> {setDate(e.target.value)}}

              type="date"
              name="date"
            />
            
        
            <TextArea labelText={t("Description (Ar)")} value={textAr} onChange={(e) => setTextAr(e.target.value)} required={true} />
 <TextArea labelText={t("Description (En)")} value={textEn} onChange={(e) => setTextEn(e.target.value)} required={true} />
  <label  className="pb-2 text-tcolor-5  text-md font-kufi">
              {t("Upload Image")}
              <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              name=""
              id="upload"
              className="hidden"
              onChange={inmageHandle}
            />
  
            {imageShow ? (
              <div className="h-[180px] relative">
                <label htmlFor="0">
                  <img
                    className="w-full h-full rounded-lg border"
                    src={imageShow.url} // الوصول إلى url مباشرةً
                    alt=""
                    style={{
                      borderColor: currentColor,
                    }}
                  />
                </label>
                <input
                  onChange={(e) => changeImage(e.target.files[0])}
                  type="file"
                  id="0"
                  className="hidden"
                />
                <span
                  onClick={removeImage}
                  className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                  style={{ backgroundColor: currentColor }}
                >
                  <IoCloseSharp />
                </span>
              </div>
            ) : (
              <label
                className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
                htmlFor="image"
                style={{
                  borderColor: currentColor,
                }}
              >
                <span>
                  <BsImages size={40} color={currentColor} />
                </span>
                <span
                  className=" text font-kufi text-md"
                  style={{
                    color: currentColor,
                  }}
                >
                  {t("Select Image")}
                </span>
              </label>
            )}
  
            <input
              onChange={inmageHandle}
              className="hidden"
              type="file"
              id="image"
            />
            <br />
          </div>
          <DSpinButton isLoading={isSpinner}>{t("Edit")}</DSpinButton>
        </form>
      </div>
    )
  }</>

  );
}

export default EditReview;